/* Joeps - vergelijk-functie voor telefoons/tablets.
   Kaart-toggle -> localStorage -> sticky balk -> overlay met specs naast elkaar. */
(function () {
  var KEY = 'joeps_cmp', MAX = 4;
  var bar = document.querySelector('[data-compare-bar]');
  if (!bar) return;
  var itemsEl = bar.querySelector('[data-cmp-items]');
  var countEl = bar.querySelector('[data-cmp-count]');
  var overlay = document.querySelector('[data-compare-overlay]');
  var tableEl = overlay ? overlay.querySelector('[data-cmp-table]') : null;

  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function inList(h) { return load().some(function (x) { return x.handle === h; }); }
  function add(item) {
    var a = load();
    if (a.length >= MAX) { alert('Je kunt maximaal ' + MAX + ' toestellen tegelijk vergelijken.'); return; }
    if (!inList(item.handle)) { a.push(item); save(a); }
  }
  function remove(h) { save(load().filter(function (x) { return x.handle !== h; })); }

  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function syncToggles() {
    var a = load();
    document.querySelectorAll('[data-compare-toggle]').forEach(function (t) {
      var on = a.some(function (x) { return x.handle === t.getAttribute('data-cmp-handle'); });
      t.classList.toggle('is-on', on);
      var cb = t.querySelector('input'); if (cb) cb.checked = on;
    });
  }
  /* De hoogte van de balk doorgeven aan de CSS. Zonder dat compenseerde alleen
     de productpagina, en dan nog maar voor een balk: met iets in de
     vergelijklijst waren de drie voetlinks op geen enkele scrollpositie meer
     aan te tikken, en op een collectiepagina lag de balk over de knop Toon
     resultaten. Nu rekent de pagina zelf uit hoeveel ruimte er onderaan bij moet. */
  function hoogteDoorgeven(zichtbaar) {
    var h = zichtbaar ? (bar.getBoundingClientRect().height || 67) : 0;
    document.documentElement.style.setProperty('--cmp-h', Math.round(h) + 'px');
    document.body.classList.toggle('has-cmp-bar', !!zichtbaar);
  }
  function renderBar() {
    var a = load();
    if (!a.length) { bar.hidden = true; hoogteDoorgeven(false); return; }
    bar.hidden = false;
    itemsEl.innerHTML = a.map(function (x) {
      return '<span class="cmp-bar__chip"><img src="' + esc(x.img) + '" alt="" loading="lazy"><b>' + esc(x.title) + '</b>' +
        '<button type="button" class="cmp-bar__x" data-cmp-remove="' + esc(x.handle) + '" aria-label="Verwijderen">&times;</button></span>';
    }).join('');
    if (countEl) countEl.textContent = a.length;
    /* Met een toestel valt er niets te vergelijken. De knop zag er wel actief uit
       en gaf dan een kale browserpopup; nu staat hij uit met uitleg. */
    var goEl = bar.querySelector('[data-cmp-go]');
    if (goEl) {
      var kan = a.length > 1;
      goEl.disabled = !kan;
      goEl.setAttribute('aria-disabled', kan ? 'false' : 'true');
      goEl.title = kan ? '' : 'Kies nog een toestel om te vergelijken';
    }
    hoogteDoorgeven(true);
  }
  function refresh() { syncToggles(); renderBar(); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-compare-toggle]');
    if (t) {
      e.preventDefault(); e.stopPropagation();
      var h = t.getAttribute('data-cmp-handle');
      if (inList(h)) remove(h);
      else add({ handle: h, title: t.getAttribute('data-cmp-title'), img: t.getAttribute('data-cmp-img') });
      refresh();
      return;
    }
    var rm = e.target.closest('[data-cmp-remove]');
    if (rm) { remove(rm.getAttribute('data-cmp-remove')); refresh(); return; }
    if (e.target.closest('[data-cmp-clear]')) { save([]); refresh(); return; }
    if (e.target.closest('[data-cmp-go]')) { openCompare(); return; }
    if (e.target.closest('[data-cmp-close]') || e.target === overlay) { closeCompare(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay && !overlay.hidden) closeCompare(); });

  function openCompare() {
    var a = load();
    if (a.length < 2) { alert('Kies minstens 2 toestellen om te vergelijken.'); return; }
    if (!overlay) return;
    overlay.hidden = false; document.body.style.overflow = 'hidden';
    tableEl.innerHTML = '<div class="cmp-loading"><span class="cmp-spinner"></span>Vergelijking laden…</div>';
    /* Onthouden wat we al hebben gehaald. Elke opening haalde vier volledige
       productpagina's op van ruim 200 kB per stuk, ook als je dezelfde twee
       toestellen net had vergeleken. */
    if (!window.__jpCmpCache) window.__jpCmpCache = {};
    var cache = window.__jpCmpCache;
    Promise.all(a.map(function (x) {
      if (cache[x.handle]) return Promise.resolve(cache[x.handle]);
      return fetch('/products/' + x.handle).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var specs = {}, order = [];
        doc.querySelectorAll('[data-ppanel="specs"] .pdp-specs__row').forEach(function (row) {
          var k = (row.querySelector('.pdp-specs__k') || {}).textContent;
          /* De (i)-tooltip staat BINNEN de waarde en is alleen visueel verborgen,
             dus textContent plakte de hele uitleg achter het antwoord: 'Nee Dit
             toestel is hetzelfde als het model voor de Nederlandse markt...'.
             Kopie maken, tooltip eruit, dan pas lezen. */
          var vEl = row.querySelector('.pdp-specs__v');
          var v = '';
          if (vEl) {
            var kopie = vEl.cloneNode(true);
            kopie.querySelectorAll('.spec-i').forEach(function (el) { el.remove(); });
            v = kopie.textContent;
          }
          if (k) { k = k.trim(); if (!(k in specs)) order.push(k); specs[k] = (v || '').trim(); }
        });
        var priceEl = doc.querySelector('[data-pdp-price]');
        var stockEl = doc.querySelector('[data-pdp-stock]');
        var stock = stockEl ? stockEl.textContent.replace(/\s+/g, ' ').trim() : '';
        if (/in bestelling/i.test(stock)) stock = stock;
        else if (/op voorraad/i.test(stock)) stock = 'Op voorraad';
        else if (/uitverkocht/i.test(stock)) stock = 'Uitverkocht';
        var rij = { handle: x.handle, title: x.title, img: x.img, price: priceEl ? priceEl.textContent.trim() : '', stock: stock, specs: specs, order: order };
        cache[x.handle] = rij;
        return rij;
      }).catch(function () { return { handle: x.handle, title: x.title, img: x.img, price: '', stock: '', specs: {}, order: [] }; });
    })).then(renderTable);
  }

  function renderTable(items) {
    var keys = [];
    items.forEach(function (it) { it.order.forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); }); });
    var h = '<table class="cmp-table"><thead><tr><th class="cmp-table__corner"></th>';
    items.forEach(function (it) {
      h += '<th><a class="cmp-table__prod" href="/products/' + esc(it.handle) + '"><img src="' + esc(it.img) + '" alt="" loading="lazy"><span>' + esc(it.title) + '</span></a>' +
        (it.price ? '<b class="cmp-table__price">' + esc(it.price) + '</b>' : '') + '</th>';
    });
    h += '</tr></thead><tbody>';
    // Altijd basisrijen zodat er nooit "niks om te vergelijken" is.
    h += '<tr><td class="cmp-table__k">Prijs</td>';
    items.forEach(function (it) { h += '<td>' + (it.price ? esc(it.price) : '–') + '</td>'; });
    h += '</tr>';
    h += '<tr><td class="cmp-table__k">Beschikbaarheid</td>';
    items.forEach(function (it) { h += '<td>' + (it.stock ? esc(it.stock) : '–') + '</td>'; });
    h += '</tr>';
    keys.forEach(function (k) {
      h += '<tr><td class="cmp-table__k">' + esc(k) + '</td>';
      items.forEach(function (it) {
        var v = it.specs[k];
        h += '<td' + (v ? '' : ' class="cmp-table__na"') + '>' + (v ? esc(v) : '–') + '</td>';
      });
      h += '</tr>';
    });
    if (!keys.length) {
      h += '<tr><td colspan="' + (items.length + 1) + '" class="cmp-table__empty">De volledige specificaties van deze toestellen worden binnenkort toegevoegd.</td></tr>';
    }
    h += '</tbody></table>';
    tableEl.innerHTML = h;
  }
  function closeCompare() { if (overlay) { overlay.hidden = true; document.body.style.overflow = ''; } }

  refresh();
  window.addEventListener('pageshow', refresh);
}());
